



















import {Component, Prop, Vue} from 'vue-property-decorator';
import {AxisBindData} from './interfaces';

@Component({})
export default class AccelerometerWidgetBindForm extends Vue {
  valid = true;

  @Prop({required: false})
  initAxis!: AxisBindData;

  axis: AxisBindData = {
    name: '',
    ru: '',
  };

  created() {
    if (this.initAxis) this.axis = this.initAxis;
  }
}
